<template>
  <div class="lego-dropdown-check-wrap" v-click-outside="toggleItemOuter">
    <button
      type="button"
      class="icon-button"
      @click="toggleDropdown"
      :style="{
        width: isSummary ? '100%' : '',
        padding: isSummary ? '10px 16px' : '0'
      }"
    >
      <div class="hover_icon">
        <lego-icon
          v-if="!isSummary"
          :iconType="btnIconType"
          :icon="btnIconName"
          :size="20"
          sm
          v-lego-tooltip="{ value: tooltip, moreAction: 'clickToHide' }"
        />
        <lego-icon
          v-if="isDropIcon && !isSummary"
          iconType="df"
          icon="arrow_down"
          sm
          :style="caretStyle"
        />
      </div>

      <div class="button-title" v-if="isSummary">
        <div style="display: flex" v-lego-tooltip:ellipsis="tooltip">
          <lego-icon :iconType="btnIconType" :icon="btnIconName" sm :size="20" />
          <div class="button-title_text">
            <slot name="buttonTitle"></slot>
          </div>
        </div>
        <lego-icon v-if="isDropIcon" iconType="df" icon="arrow_down" sm :style="caretStyle" />
      </div>
      <!-- 드롭다운 메뉴 -->
      <div class="dropdown-list" v-if="isOpenDropdown" :style="[contentSummary]">
        <div style="display: none">
          {{ dropdownData }}
        </div>
        <span
          v-for="(item, index) in dropdownData"
          class="dropdown-item"
          :class="{ active: isSelectedItem(item.iconName, btnIconName) }"
          :key="index"
          @click="doAction('click', item, index)"
        >
          <lego-icon v-if="submenuIcon" :iconType="item.iconType" :icon="item.iconName" sm />
          <em>{{ item.txt }}</em>
        </span>
      </div>
      <!-- // 드롭다운 메뉴 -->
    </button>
  </div>
</template>

<script>
export default {
  emits: ['click', 'toggle'],
  props: {
    rowId: { type: [Number, String] },
    isDropIcon: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    submenuIcon: {
      type: Boolean,
      default: false
    },
    btnIconType: {
      type: String,
      default: ''
    },
    btnIconName: {
      type: String,
      default: ''
    },
    dropdownData: {
      type: Array,
      default: null
    },
    tooltip: {
      type: String,
      default: ''
    },
    isSummary: {
      type: Boolean,
      default: false
    },
    isChartType: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // selectbox 접기/펼치기 스타일
    caretStyle() {
      let style = {};
      if (this.isOpenDropdown) {
        style['transform'] = 'rotate(-180deg)';
      }
      style['transition-duration'] = '0.3s';
      return style;
    },
    contentSummary() {
      return this.isSummary
        ? { right: '12px', minWidth: '238px' }
        : { right: '0px', width: 'max-content' };
    }
  },
  created() {
  },
  mounted() {},
  data() {
    return {
      isOpenDropdown: false,
      idxActive: null
    };
  },
  methods: {
    toggleItemOuter() {
      this.isOpenDropdown = false;
    },
    toggleDropdown() {
      this.isOpenDropdown = !this.isOpenDropdown;
      this.$emit('toggle', this.isOpenDropdown);
    },
    /********************************
     * 함수 추가함
     *******************************/
    // 액션 모음
    doAction(cmd, parms, idx) {
      //this.$toast.open('... doAction $$$$$ cmd: ' + cmd + ', parms: ' + JSON.stringify(parms, null, '  '));
      //console.log('★ doAction ', cmd, JSON.stringify(parms, null, '  '));
      if (cmd == 'click') {
        let result = { rowId: this.rowId, ...parms };
        this.idxActive = idx;


        this.$emit('click', result);
      } else {
        alert('doAction 잘못된 cmd [' + cmd + ']');
      }
    },
    isSelectedItem(itemType, currentType) {
      return itemType === currentType;
    }
  },
};
</script>

<style scoped lang="scss">
.hover_icon {
  display: flex;
}
:deep {
  .opus-icon__download_small {
    font-size: 19px !important;
  }
}
.button-title_text {
  font-size: 14px !important;
  line-height: 16px !important;
  margin-left: 12px !important;
  vertical-align: middle !important;
}
.button-title {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.icon-button {
  position: relative;
  display: flex;
  height: auto !important;
  margin: 0;
  background-color: #fff;
  border: 0;
  cursor: pointer;

  & + .icon-button {
    position: relative;
    margin-left: 8px;

    &:before {
      content: '';
      position: absolute;
      top: 4px;
      left: -6px;
      display: inline-block;
      width: 1px;
      height: 14px;
      background-color: #d2d3d6;
    }
  }

  :deep .lego-icon {
    margin: 0;
    padding: 0;
  }

  :deep .lego-icon--small {
    font-size: 18px;
  }

  .dropdown-list {
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: column;
    margin: 24px 0 0;
    background-color: #fff;
    border-radius: 4px;
    gap: 1px;
    border: solid 1px var(--blue-with-a-hint-of-purple);
    z-index: 1;

    .dropdown-item {
      display: flex;
      align-items: center;
      gap: 8px;
      height: 34px;
      padding: 7px 10px;
      font-size: 14px;
      text-align: left;

      em {
        font-style: normal;
      }

      &:hover,
      &.active {
        color: var(--blue-with-a-hint-of-purple);
        background-color: rgba(54, 79, 199, 0.12);
      }
    }
  }
}
</style>
